import { SessionHelper } from "app/helpers/sessionHelper";
import { competitionListTimeEnum, TabTypes } from "app/utils/const";

const defaultFilters = {
  bookmarksOnly: false,
  type: TabTypes.POPULAR, // change name to euroTabName when adding asian filters, dont change now as might break a lot
  time: SessionHelper.getCompetitionListTime() || competitionListTimeEnum.TODAY,
  expandedCompetitionEvents: [],
};
export const competitionsListFiltersModel = {
  state: defaultFilters,
  reducers: {
    setFilterOption(state, payload) {
      return { ...state, ...payload };
    },
    /**
     * payload: { bookmarksOnly:boolean }
     */
    setBookmarksOnly: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, bookmarksOnly: payload };
    },
    /**
     * payload: { navigationNodeId:number  }
     */
    addExpandedCompetitionNavigationNodeId: (
      state: Record<string, any>,
      payload: number
    ): any => {
      const expandedCompetitionEvents = state.expandedCompetitionEvents || [];
      // Check if the navigationNodeId already exists in the array
      if (!expandedCompetitionEvents.includes(payload)) {
        expandedCompetitionEvents.push(payload);
      }

      return { ...state, expandedCompetitionEvents };
    },
    /**
     * payload: { navigationNodeId:number  }
     */
    removeExpandedCompetitionNavigationNodeId: (
      state: Record<string, any>,
      payload: number
    ): any => {
      const expandedCompetitionEvents = state.expandedCompetitionEvents || [];
      // Check if the navigationNodeId exists in the array
      const index = expandedCompetitionEvents.indexOf(payload);
      if (index !== -1) {
        expandedCompetitionEvents.splice(index, 1);
      }

      return { ...state, expandedCompetitionEvents };
    },
    /**
     * reset expanded competitions
     */
    resetExpandedCompetitions: (state: Record<string, any>): any => {
      return { ...state, expandedCompetitionEvents: [] };
    },
    /**
     * payload: { updateCompetitionListType:string }
     */
    updateCompetitionListType: (
      state: Record<string, any>,
      payload: Record<string, any>
    ): any => {
      return { ...state, type: payload };
    },
    /**
     * payload: { time: string }
     */
    updateCompetitionListTime: (
      state: Record<string, any>,
      payload: string
    ): any => {
      return { ...state, time: payload };
    },
    resetCompetitionListFilters: (state: Record<string, any>): any => {
      return { ...state, ...defaultFilters };
    },
  },
  effects: {},
};

export default competitionsListFiltersModel;
